import { c as _c } from "react/compiler-runtime";
import { IconX } from "@xefi/x-react/icons";
import { useTranslation } from "react-i18next";
type LoginAlertProps = {
  message: string | null;
  onClose: () => void;
  isCloseVisible?: boolean;
};
export const LoginAlert = t0 => {
  const $ = _c(10);
  const {
    message,
    onClose,
    isCloseVisible: t1
  } = t0;
  const isCloseVisible = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation();
  if (!message) {
    return null;
  }
  let t2;
  if ($[0] !== t) {
    t2 = t("actions.close");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `absolute right-[15px] top-[15px] ${isCloseVisible ? "text-black/25 hover:text-black/50" : "text-transparent"}`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconX aria-hidden={true} stroke={3} className="size-[11px]" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onClose || $[4] !== t2 || $[5] !== t3) {
    t5 = <button type="button" aria-label={t2} onClick={onClose} className={t3}>{t4}</button>;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== message || $[8] !== t5) {
    t6 = <div role="alert" className="relative mb-5 rounded border border-[#fbe1e3] bg-[#fbe1e3] py-[15px] pl-[15px] pr-8 text-sm leading-5 text-[#e73d4a]">{t5}{message}</div>;
    $[7] = message;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};